import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { Permission } from "@/lib/permissions";
import { usePermissions } from "@/hooks/usePermissions";

export function PermissionRoute({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { hasPermission } = usePermissions();
  return hasPermission(permission) ? children : <Navigate to="/" replace />;
}
